import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import MediaCard from "@/components/MediaCard";
import { Heart, Loader2 } from "lucide-react";

export default function SharedFavorites() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let title = document.title;
    api.get(`/shared-favorites/${token}`)
      .then((r) => { setData(r.data); document.title = `Favoris de ${r.data.owner_name} · Chaînes RDC`; })
      .catch(() => setError(true));
    return () => { document.title = title; };
  }, [token]);

  if (error) return (
    <div className="max-w-lg mx-auto px-4 text-center py-24" data-testid="shared-favorites-error">
      <Heart className="mx-auto text-muted-foreground mb-3" size={40} />
      <h1 className="font-heading font-bold text-2xl">Liste introuvable</h1>
      <p className="text-muted-foreground mt-2">Ce lien de favoris n'est plus valide.</p>
      <Link to="/" className="inline-flex mt-5 rounded-full bg-primary text-white px-6 py-2.5 font-semibold">Explorer les chaînes</Link>
    </div>
  );

  if (!data) return <div className="flex justify-center py-24"><Loader2 className="animate-spin text-primary" size={32} /></div>;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6" data-testid="shared-favorites-page">
      <div className="flex items-center gap-2.5 mb-1">
        <span className="w-9 h-9 rounded-full bg-rdcred/10 text-rdcred flex items-center justify-center"><Heart size={18} fill="currentColor" /></span>
        <h1 className="font-heading font-extrabold text-2xl sm:text-3xl tracking-tight">Les favoris de {data.owner_name}</h1>
      </div>
      <p className="text-muted-foreground mb-6 text-sm">{data.count} chaîne{data.count > 1 ? "s" : ""} partagée{data.count > 1 ? "s" : ""}</p>
      {data.items.length === 0 ? (
        <p className="text-muted-foreground text-center py-16">Cette liste de favoris est vide.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {data.items.map((m, i) => <MediaCard key={m.id} media={m} index={i} />)}
        </div>
      )}
    </div>
  );
}
